import http from "./http-common";
import axios from "axios";
import * as Constants from '../Constants';

class RestService {

  fediverseRegisterApp(instance, type) {
    
    let data = {
      instance: instance,
      type: type
    }

    return http.post("/auth/register", data);
  }

  fediverseSignIn(code, instance, type) {

    if (type === 'Mastodon') {
      this.mastodonSignIn(code, instance);
    } else if (type === 'Pixelfed') {
      this.pixelfedSignIn(code, instance);
    }
  }

  mastodonSignIn(code, mastodonInstance) {

    let data = {
      code: code,
      instance: mastodonInstance
    }

    return http.post("/auth/mastodonSignIn", data)
    .then(function (response) {

      localStorage.setItem('jwt', response.data.accessToken);
      localStorage.setItem('MastodonToken', response.data.mastodonToken); 

      axios.defaults.headers.common['Authorization'] = response.data.tokenType + " " + response.data.accessToken;

      window.location.href = "/main"
    })
    .catch(function (error) {
      console.log("CATCH:" + error);
      window.location.href = "/error"
    });
  }

  pixelfedSignIn(code, pixelfedInstance) {

    let data = {
      code: code,
      instance: pixelfedInstance
    }

    const instance = axios.create({
      baseURL: Constants.URL_BASE_API + "/api",
      headers: {
        "Content-type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem('jwt'),
      }
    });

    return instance.post("/pixelfed/signIn", data).then(function (response) {

      localStorage.setItem('pixelfedToken', response.data);
      localStorage.setItem('pixelfedInstance', pixelfedInstance);
      window.location.href = "/followings"
    })
    .catch(function (error) {
      console.log("CATCH:" + error);
      window.location.href = "/error"
    });;
  }

  getPendingFollowings(token, pixelfedInstance, lastIndex) {

    let data = {
      token: token,
      instance: pixelfedInstance,
      lastIndex: lastIndex,
    }

    const instance = axios.create({
      baseURL: Constants.URL_BASE_API + "/api",
      headers: {
        "Content-type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem('jwt'),
      }
    });

    return instance.post("/pixelfed/getPendingFollowings", data);
  }

  follow(token, pixelfedInstance, user) {

    let data = {
      token: token,
      instance: pixelfedInstance,
      pixelfedUserId: user.pixelfedUserId,
      pixelfedFullUsername: user.pixelfedUsername + "@" + user.pixelfedInstance,
      mastodonFullUsername: user.mastodonUsername + "@" + user.mastodonInstance
    }

    const instance = axios.create({
      baseURL: Constants.URL_BASE_API + "/api",
      headers: {
        "Content-type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem('jwt'),
      }
    });

    return instance.post("/pixelfed/follow", data);

  }

  setNotifications(enabled) {

    let data = {
      notificationEnabled: enabled
    }

    const instance = axios.create({
      baseURL: Constants.URL_BASE_API + "/api",
      headers: {
        "Content-type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem('jwt'),
      }
    });

    return instance.post("/user/setNotifications", data);

  }

  toot(token, mastodonInstance, toot) {

    let data = {
      token: token,
      instance: mastodonInstance,
      toot: toot
    }

    const instance = axios.create({
      baseURL: Constants.URL_BASE_API + "/api",
      headers: {
        "Content-type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem('jwt'),
      }
    });

    return instance.post("/mastodon/toot", data);

  }
}

const RestServiceStatic = new RestService();

export default RestServiceStatic;
